// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/WikiCorbeille.js
//  WikiCorbeille
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { THEME } from "../../socle/theme";
import { wCat } from "./constantes";
import { wBtnSm, wGhostSm, wPanel } from "./styles";

// ═══════════════ Corbeille (lot 2) ═══════════════
export function WikiCorbeille({ api, onRetour, onOuvrir }) {
  const [pages, setPages] = useState(null);
  const [erreur, setErreur] = useState("");

  const charger = useCallback(() => api.liste("statut=corbeille").then(setPages).catch((e) => { setErreur(e.message); setPages([]); }), [api]);
  useEffect(() => { charger(); }, [charger]);

  const restaurer = async (p) => {
    try { await api.statut(p.id, "brouillon"); charger(); } catch (e) { setErreur(e.message); }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <button onClick={onRetour} style={wGhostSm}>← Wiki</button>
        <h2 style={{ color: THEME.text, fontSize: 18, fontWeight: 800, margin: 0 }}>🗑️ Corbeille</h2>
      </div>
      <div style={{ color: THEME.textMuted, fontSize: 12.5 }}>
        Les pages supprimées restent ici avec tout leur historique. Restaurer les remet en brouillon.
      </div>
      {erreur && <div style={{ color: THEME.red, fontSize: 12.5 }}>{erreur}</div>}
      {!pages && <div style={{ color: THEME.textMuted }}>Chargement…</div>}
      {pages && pages.length === 0 && (
        <div style={{ ...wPanel, textAlign: "center", color: THEME.textMuted, fontSize: 13, padding: 40 }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>🗑️</div>La corbeille est vide.
        </div>
      )}
      {(pages || []).map((p) => (
        <div key={p.id} style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 10, padding: "12px 16px", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ color: THEME.text, fontWeight: 600, fontSize: 13.5 }}>
              {wCat(p.categorie).icone} {p.titre}
            </div>
            <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 3 }}>
              {p.editeur || p.auteur || "—"} · v{p.version} · supprimée le {new Date(p.updated_at).toLocaleDateString("fr")}
            </div>
          </div>
          <button onClick={() => onOuvrir(p.slug)} style={wGhostSm}>Voir</button>
          <button onClick={() => restaurer(p)} style={wBtnSm(THEME.emeraldDim, THEME.emerald, THEME.emerald)}>↩ Restaurer</button>
        </div>
      ))}
    </div>
  );
}
